import { useMemo } from "react";
import { useSyncedResource } from "hooks/useSyncedResource.hook";
import * as SCOPE from "services/sync/scope";
import useInfrastructure from "hooks/useInfrastructure.hook";
import * as linesSync from "services/sync/resources/chat/lines.sync";

export function useChatLines({ enabled = true } = {}) {
  const { syncEngine, repositories } = useInfrastructure();
  const repository = repositories.lines;

  enabled = enabled;
  const scope = SCOPE.CHAT.LINES;
  const key = useMemo(() => "(all)", []);
  const syncParams = useMemo(() => ({}), []);

  return useSyncedResource({
    enabled,
    scope,
    key,
    cacheFn: ({ scope, key }) => repository.getFromCache(scope, key, () => repository.getAll()),
    syncParams,
    syncFn: linesSync.all,
    syncEngine,
    repository,
    repositories,
    deps: []
  });
}